import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-test": "member-report-link"
}
const _hoisted_2 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_3 = ["href"]

import { TeamCurrentMemberReportLinkApiModel } from "../../api-models";


export default /*#__PURE__*/_defineComponent({
  __name: 'team-member-report-link',
  props: {
    link: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (!!_ctx.link)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        (!_ctx.link.linkUrl)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.link.linkText), 1))
          : (_openBlock(), _createElementBlock("a", {
              key: 1,
              href: _ctx.link.linkUrl,
              target: "_blank",
              rel: "noopener noreferrer"
            }, _toDisplayString(_ctx.link.linkText), 9, _hoisted_3))
      ]))
    : _createCommentVNode("", true)
}
}

})